import { useEffect } from 'react';

const useViewportHeight = () => {
  useEffect(() => {
    const setVhProperty = () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Set the value on load
    setVhProperty();

    // Set the value on resize
    window.addEventListener('load', setVhProperty);
    window.addEventListener('resize', setVhProperty);
    
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', setVhProperty);
      window.removeEventListener('load', setVhProperty);
    };
  }, []);
};

export default useViewportHeight;